<template>
<div>
  <v-card>
    <v-card-title>
      {{ titulo }}
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fas fa-search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="banks"
      :search="search"
      sort-by="payment_date"
      sort-desc
      class="elevation-1"
      :loading="loading"
      loading-text="Consultando datos... Espere por favor"
      show-expand
      :single-expand="true"
      :expanded.sync="expanded"
    >
      
      <template v-slot:[`item.payment_period`]="{ item }">
        <v-chip class="text--primary" color="grey lighten-4" label>
          <v-icon left small>mdi-calendar-range</v-icon>
          {{ dateFormat(item.start_date) + ' ~ ' + dateFormat(item.end_date) }}
        </v-chip>
      </template>

      <!-- Fecha de pago -->
      <template v-slot:[`item.payment_date`]="{ item }">
        <span class="font-light-medium">{{ dateFormat(item.payment_date) }}</span>
      </template>
      <!-- Monto -->
      <template v-slot:[`item.amount`]="{ item }">
        {{ numberWithCommas(item.amount) }}
      </template>

      <!-- Barra superior -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>

          <v-dialog v-model="dialog" persistent max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn ref="boton2" color="primary" dark v-on="on">Nuevo Registro</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <!-- Colaborador -->
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="editedItem.id_employee"
                          :items="employees"
                          :rules="editedItem.employeeRules"
                          item-text="name"
                          item-value="id"
                          label="Escoge un colaborador"
                          @change="getEmployees"
                          clearable
                          rounded
                          solo
                        ></v-autocomplete>
                      </v-col>

                      <!-- Rango de fechas -->
                      <v-col cols="12">
                        <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value="editedItem.dates"
                          persistent
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dateRangeText"
                              label="Período a Pagar"
                              prepend-icon="fa-calendar-alt"
                              :rules="editedItem.datesRules"
                              readonly
                              filled
                              rounded
                              clearable
                              :disabled="loading"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="editedItem.dates"
                            range
                            :title-date-format="title"
                            scrollable
                            :max="today"
                          >
                            <v-row no-gutters style="flex-wrap: nowrap;">
                              <v-btn class="flex-grow-1" large rounded outlined color="primary" @click="modal = false">
                                Cancelar
                              </v-btn>
                              <v-btn class="flex-grow-1" large rounded color="primary" @click="$refs.dialog.save(editedItem.dates); updateDateFilter();">
                                Aceptar
                              </v-btn>
                            </v-row>
                          </v-date-picker>
                        </v-dialog>
                      </v-col>

                      <!-- Valor a pagar -->
                      <v-col cols="12">
                        <v-text-field
                          v-model="editedItem.amount"
                          readonly
                          :rules="editedItem.amountRules"
                          label="Valor a Pagar"
                          append-outer-icon="fas fa-dollar-sign"
                        ></v-text-field>
                      </v-col>

                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="450">
            <v-card>
              <v-card-title>
                <span>¿Desea eliminar el pago de {{ editedItem.employee }}?</span>
                <v-spacer></v-spacer>
              </v-card-title>

              <v-card-actions>
                <v-btn color="green darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="red" text @click="eliminar">Aceptar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Acciones -->
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" color="red" small @click="deleteItem(item)">fas fa-trash-alt</v-icon>
          </template>
          <span>Eliminar pago</span>
        </v-tooltip>
      </template>

      <!-- DETALLE (Fila expandida) -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-0">
          <v-card flat class="pa-4">
            <!-- Encabezado del detalle -->
            <div class="d-flex align-center mb-3">
              <v-icon class="mr-2">mdi-clipboard-text</v-icon>
              <div class="subtitle-1 font-weight-medium">Detalle de días pagados</div>
              <v-spacer></v-spacer>
              <!-- Chips de resumen (si no viene del backend, se calcula en el cliente) -->
              <template v-if="getSummary(item)">
                <v-chip small class="mr-2" color="blue lighten-5" text-color="blue darken-2" label>
                  <v-icon left small>mdi-briefcase-check</v-icon>
                  Días completos: {{ getSummary(item).full_days }}
                </v-chip>
                <v-chip small class="mr-2" color="amber lighten-5" text-color="amber darken-3" label>
                  <v-icon left small>mdi-timer-outline</v-icon>
                  Medios días: {{ getSummary(item).half_days }}
                </v-chip>
                <v-chip small color="grey lighten-4" class="black--text" label>
                  <v-icon left small>mdi-sigma</v-icon>
                  Equivalencia: {{ getSummary(item).days_equiv }}
                </v-chip>
              </template>
            </div>

            <!-- Tabla de asistencias -->
            <v-simple-table dense class="rounded-lg">
              <thead>
                <tr>
                  <th style="white-space:nowrap;">Fecha</th>
                  <th>Tipo de jornada</th>
                  <th style="text-align:right; white-space:nowrap;">Equivalencia</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!item.attendances || item.attendances.length === 0">
                  <td :colspan="3">
                    <v-alert dense outlined type="info" class="my-2">
                      No hay asistencias registradas en el período pagado.
                    </v-alert>
                  </td>
                </tr>

                <tr v-for="att in (item.attendances || [])" :key="att.attendance_id">
                  <td style="white-space:nowrap;">{{ dateFormat(att.date) }}</td>
                  <td>
                    <v-chip
                      small
                      :color="Number(att.fulltime) === 1 ? 'blue lighten-5' : (Number(att.part_time) === 1 ? 'amber lighten-5' : 'grey lighten-4')"
                      :class="Number(att.fulltime) === 1 ? 'blue--text text--darken-2' : (Number(att.part_time) === 1 ? 'amber--text text--darken-3' : 'black--text')"
                      label
                    >
                      <v-icon left small>
                        {{ Number(att.fulltime) === 1 ? 'mdi-briefcase-check' : (Number(att.part_time) === 1 ? 'mdi-timer-outline' : 'mdi-minus') }}
                      </v-icon>
                      {{ attendanceTypeEs(att) }}
                    </v-chip>
                  </td>
                  <td style="text-align:right;">
                    <span class="font-weight-medium">{{ dayEquiv(att) }}</span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <!-- Comparativo (opcional si backend lo envía) -->
            <div
              v-if="item.expected_amount_by_days && item.amount"
              class="d-flex align-center justify-end mt-3"
            >
              <v-chip small class="mr-2" color="grey lighten-4" label>
                <v-icon left small>mdi-calculator</v-icon>
                Calc. por días: {{ numberWithCommas(item.expected_amount_by_days) }}
              </v-chip>
              <v-chip small class="mr-2" color="green lighten-5" text-color="green darken-2" label>
                <v-icon left small>mdi-cash</v-icon>
                Pagado: {{ numberWithCommas(item.amount) }}
              </v-chip>
              <v-chip
                small
                :color="diffColor(item)"
                :class="diffClass(item)"
                label
              >
                <v-icon left small>mdi-scale-balance</v-icon>
                Dif.: {{ diffFormatted(item) }}
              </v-chip>
            </div>
          </v-card>
        </td>
      </template>

      <!-- Estado sin datos -->
      <template v-slot:no-data>
        <v-container class="text-center py-6">
          <v-icon large class="mb-2">mdi-file-document-outline</v-icon>
          <div class="subtitle-2">No hay pagos registrados aún.</div>
        </v-container>
      </template>

    </v-data-table>
  </v-card>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as moment from 'moment';
import axios from "axios";
export default {
  name: "payroll_payments",
  data: () => ({
    dialog: false,
    banks: [],
    employees: [],
    menu: false,
    dialogDelete: false,
    modal: false,
    search: "",
    loading: "",
    titulo: "Pagos de Planilla",
    expanded: [],
    headers: [
      { text: "RTN", align: "left", value: "rtn" },
      { text: "Nombre", align: "left", value: "employee" },
      { text: "Fecha de Pago", align: "left", value: "payment_date" },
      { text: "Período de Pago", align: "left", value: "payment_period" },
      { text: "Valor", align: "left", value: "amount" },
      { text: "Acciones", value: "action", sortable: false }
    ],
    editedIndex: -1,

    valid: true,
    editedItem: {
      id: "",
      amount: "",
      id_employee: null,
      dates: [],
      employeeRules: [v => !!v || "Escoge el colaborador"],
      amountRules: [v => !!v || "El valor debe ser mayor a 0"],
      datesRules: [v => !!v || "Escoge el período a pagar"],
    },
    defaultItem: {
      id_employee: null,
      amount: "",
      dates: [],
      employeeRules: [v => !!v || "Escoge el colaborador"],
      amountRules: [v => !!v || "El valor debe ser mayor a 0"],
      datesRules: [v => !!v || "Escoge el período a pagar"],
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Registro" : "Editar Registro";
    },
    ...mapState(["db","headers_db"]),
    dateRangeText: {
      get() { return this.editedItem.dates.join(' ~ ') },
      set() { this.editedItem.dates = [] }
    },
    today() { return new Date().toISOString().substr(0, 10); },
  },

  watch: {
    dialog(val) { val || this.close(); }
  },

  methods: {
    ...mapActions(["validateSession"]),
    // --- Endpoints ---
    async getBanks(){
      await axios.get(this.db + 'payroll/paids',
        { headers: this.headers_db }
      ).then(response => {
        // Se espera que cada item pueda traer:
        // attendances: [{attendance_id,date,part_time,fulltime}]
        // summary (opcional): {full_days, half_days, days_equiv}
        // expected_amount_by_days (opcional)
        this.banks = response.data.data || [];
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.validateSession(error).then((resp) => { if(resp) this.getBanks(); })
      });
    },

    async getEmployees(){
      await axios.get(this.db + 'payroll/employees',
        { headers: this.headers_db }
      ).then(response => {
        this.employees = response.data.data;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.validateSession(error).then((resp) => { if(resp) this.getEmployees(); })
      });
    },

    async getAmountToPay(){
      await axios.get(`${this.db}payroll/amountopay`,
        {
          headers: this.headers_db,
          params: {
            id_employee: this.editedItem.id_employee,
            start_date: this.editedItem.dates[0],
            end_date: this.editedItem.dates[1]
          }
        }
      ).then(response => {
        this.editedItem.amount = response.data.data.total_to_pay || 0;
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.validateSession(error).then((resp) => { if(resp) this.getAmountToPay(); })
      });
    },

    addProcess(payload){
      payload.start_date = payload.dates[0];
      payload.end_date = payload.dates[1];
      axios.post(this.db + 'payroll/payment/add', payload,
      { headers: this.headers_db }
      ).then((response) => {
        this.$store.dispatch("setSnackbar", { text: response.data.message });
        this.banks.push(this.editedItem);
        this.getBanks();
        this.close();
      })
      .catch((error) => {
        this.validateSession(error).then((resp) => { if(resp) this.addProcess(payload); })
      });
    },

    updateProcess(payload){
      axios.post(this.db + 'payroll/payment/update', payload,
      { headers: this.headers_db }
      ).then((response) => {
        this.$store.dispatch("setSnackbar", { text: response.data.message });
      })
      .catch((error) => {
        this.validateSession(error).then((resp) => { if(resp) this.updateProcess(payload); })
      });
    },

    deleteProcess(item){
      axios.post(this.db + 'payroll/payment/delete', item,
      { headers: this.headers_db }
      ).then(() => {
        this.banks = this.banks.filter(doc => doc.id != item.id)
      })
      .catch((error) => {
        this.validateSession(error).then((resp) => { if(resp) this.deleteProcess(item); })
      });
    },
    // --- FIN endpoints ---

    // Generales
    dateFormat(date) { return moment(date).format('DD/MM/YYYY'); },
    title() { return "Selecciona las fechas a filtrar"; },

    updateDateFilter() {
      if (this.editedItem.dates.length > 1) {
        if (moment(this.editedItem.dates[0], "YYYY-MM-DD") > new Date(this.editedItem.dates[1])) {
          this.editedItem.dates = [this.editedItem.dates[1], this.editedItem.dates[0]];
        }
      } else {
        this.editedItem.dates = [this.editedItem.dates[0], this.editedItem.dates[0]];
      }
      this.getAmountToPay();
    },

    async editItem(item) {
      item.status = item.status == 1 ? true : false;
      this.editedIndex = this.banks.indexOf(item);
      this.dialog = true;
      this.editedItem = Object.assign({}, item);
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    close() {
      this.dialog = false;
      this.dialogDelete = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.$refs.form.validate()) {
        this.editedItem.status = this.editedItem.status ? 1 : 0;

        if (this.editedIndex > -1) {
          Object.assign(this.banks[this.editedIndex], this.editedItem);
          this.updateProcess(this.editedItem);
          this.close();
        } else {
          this.addProcess(this.editedItem);
        }
      }
    },

    eliminar() {
      this.deleteProcess(this.editedItem);
      this.close();
    },

    numberWithCommas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); },

    // Helpers detalle (100% español)
    attendanceTypeEs(att) {
      if (att && Number(att.fulltime) === 1) return 'Día completo';
      if (att && Number(att.part_time) === 1) return 'Medio día';
      return '—';
    },
    dayEquiv(att) {
      if (att && Number(att.fulltime) === 1) return '1.0';
      if (att && Number(att.part_time) === 1) return '0.5';
      return '0';
    },
    // Usa el summary del backend si existe; si no, lo calcula.
    getSummary(item) {
      if (!item) return null;
      if (item.summary) return item.summary;
      if (!item.attendances || item.attendances.length === 0) {
        return { full_days: 0, half_days: 0, days_equiv: 0 };
        }
      const full = item.attendances.filter(a => Number(a.fulltime) === 1).length;
      const half = item.attendances.filter(a => Number(a.part_time) === 1).length;
      const equiv = (full * 1) + (half * 0.5);
      return { full_days: full, half_days: half, days_equiv: Number(equiv.toFixed(2)) };
    },
    // Diferencias (si el backend trae expected_amount_by_days)
    diffValue(item) {
      if (!item || !item.expected_amount_by_days || !item.amount) return 0;
      const expected = Number(item.expected_amount_by_days);
      const paid = Number(item.amount);
      return Number((paid - expected).toFixed(2));
    },
    diffFormatted(item) {
      const d = this.diffValue(item);
      const sign = d > 0 ? '+' : '';
      return sign + this.numberWithCommas(d.toFixed(2));
    },
    diffColor(item) {
      const d = this.diffValue(item);
      if (d === 0) return 'grey lighten-4';
      return d > 0 ? 'green lighten-5' : 'red lighten-5';
    },
    diffClass(item) {
      const d = this.diffValue(item);
      if (d === 0) return 'black--text';
      return d > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2';
    }
  },

  created() {
    this.getEmployees();
    this.getBanks();
  }
};
</script>

<style scoped>
/* Detalles sutiles de UI */
.v-data-table .v-data-table__expanded__content {
  background: #fafafa;
}
.rounded-lg {
  border-radius: 16px;
}
</style>
